<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :script="itemsCode" :tabs="tabs">
      <v-layout>
        <v-main height="450">
          <div class="d-flex flex-column align-center">
            <v-card elevation="4" class="ma-2" width="420" height="auto">
              <v-card-title class="font-weight-bold">Single Select</v-card-title>
              <v-card-text>
                <CsSelect
                  v-model="selectedPath"
                  :label="label ? 'Filter by country' : undefined"
                  :optional-text="optionalText ? '(Optional)' : undefined"
                  :mandatory="mandatory ? true : undefined"
                  :placeholder="placeholder ? 'Select an option' : ''"
                  :items="items"
                  :helper-message="helperMessage ? 'Helper message' : undefined"
                  :error-messages="errorMessages ? 'Error message' : undefined"
                  :disabled="disabled ? true : undefined"
                  :width="width ? '300' : undefined"
                  :is-nested="isNested"
                  @update:model-value="handleSelect"
                />
              </v-card-text>
              <v-card-text class="pt-0 text-caption">
                <div>v-model: {{ JSON.stringify(selectedPath) }}</div>
              </v-card-text>
            </v-card>
          </div>
        </v-main>
      </v-layout>
      <template #configuration>
        <div class="d-flex flex-column">
          <v-checkbox v-model="label" label="Label" />
          <v-checkbox v-model="optionalText" label="Optional Text" />
          <v-checkbox v-model="mandatory" label="Mandatory" />
          <v-checkbox v-model="placeholder" label="Placeholder" />
          <v-checkbox v-model="helperMessage" label="Helper Message" />
          <v-checkbox v-model="errorMessages" label="Error Messages" />
          <v-checkbox v-model="disabled" label="Disabled" />
          <v-checkbox v-model="width" label="Width" />
          <v-checkbox v-model="isNested" label="Nested" />
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'CustomCSSelect',
  components: { UsageExample },
  setup() {
    const code = `// v-model is the path of values down to the selection,
// e.g. ['vegetables', 'root', 'carrot']. Empty means nothing selected.
<CSSelect
        v-model="selectedPath"
        :label="label ? 'Filter by country' : undefined"
        :optional-text="optionalText ? '(Optional)' : undefined"
        :mandatory="mandatory ? true : undefined"
        :placeholder="placeholder ? 'Select an option' : undefined"
        :items="items"
        :helper-message="helperMessage ? 'Helper message' : undefined"
        :error-messages="errorMessages ? 'Error message' : undefined"
        :disabled="disabled ? true : undefined"
        :width="width ? '300' : undefined"
        :is-nested="isNested"
        @update:model-value="handleSelect"
      />
    `;

    const itemsCode = `// A child is nested under its parent's \`children\`, to any depth.
// An item without \`children\` is a leaf, at any level.
items: [
  {
    title: 'Vegetables',
    value: 'vegetables',
    children: [
      {
        title: 'Root',
        value: 'root',
        children: [
          { title: 'Carrot', value: 'carrot' },
          { title: 'Turnip', value: 'turnip' },
          {
            title: 'Celeriac with a name long enough to be truncated and show a tooltip',
            value: 'celeriac'
          }
        ]
      },
      { title: 'Carrot Cake', value: 'carrot-cake' }
    ]
  }
]`;

    return {
      code,
      itemsCode
    };
  },
  data() {
    return {
      tab: 'Select Usage',
      tabs: ['Select Usage'],
      items: [
        {
          title: 'Vegetables',
          value: 'vegetables',
          children: [
            {
              title: 'Root',
              value: 'root',
              children: [
                { title: 'Carrot', value: 'carrot' },
                { title: 'Turnip', value: 'turnip' },
                {
                  title: 'Celeriac with a name long enough to be truncated and show a tooltip',
                  value: 'celeriac'
                }
              ]
            },
            { title: 'Carrot Cake', value: 'carrot-cake' }
          ]
        }
      ],
      selectedPath: [],
      label: true,
      optionalText: undefined,
      mandatory: undefined,
      placeholder: true,
      helperMessage: undefined,
      errorMessages: undefined,
      disabled: undefined,
      width: true,
      isNested: true
    };
  },
  methods: {
    handleSelect(path) {
      console.log('CSSelect update:modelValue', path);
    }
  }
};
</script>

<style lang="scss">
.v-overlay__content.cs-select__content {
  max-width: 300px !important;
}
</style>
